import { Dropdown } from "@jetblue/kit/dropdown";
import { Incrementer } from "@jetblue/kit/incrementer";
import type { PassengersControl } from "../../use-passengers";
import { MAX_CHILDREN_WITHOUT_ADULT } from "../../use-passengers";
import type { FlightSearchFormLabels } from "../../labels";

export type PassengersInputDesktopProperties = {
  controlAdults: PassengersControl;
  controlChildren: PassengersControl;
  controlInfants: PassengersControl;
  labels: FlightSearchFormLabels["passengersDropdown"];
  passengersButtonLabel: string;
};
export const PassengersInputDesktop = ({
  controlAdults,
  controlChildren,
  controlInfants,
  labels,
  passengersButtonLabel,
}: PassengersInputDesktopProperties) => {
  const adultLabel = " " + labels.adult.toLowerCase();
  const childLabel = " " + labels.child.toLowerCase();
  const infantLabel = " " + labels.infant.toLowerCase();
  return (
    <Dropdown
      className="cursor-pointer"
      contentClassName="rounded-t-none max-w-[395px]"
      data-fs-element="traveler-selector"
      label={passengersButtonLabel}
    >
      <>
        <div
          className="
            flex justify-between border-b border-border-variant-low pb-4
          "
        >
          <div className="me-4 min-w-40">{labels.adultsRestrictions}</div>
          <Incrementer
            decrement={controlAdults.decrement}
            decrementLabel={labels.decrement + adultLabel}
            increment={controlAdults.increment}
            incrementLabel={labels.increment + adultLabel}
            isDecrementDisabled={controlAdults.isDecrementDisabled}
            isIncrementDisabled={controlAdults.isIncrementDisabled}
            name="adults"
            value={controlAdults.value}
          />
        </div>
        <div
          className="
            mt-4 flex justify-between border-b border-border-variant-low pb-4
          "
        >
          <div className="me-4 min-w-40">{labels.childrenRestrictions}</div>
          <Incrementer
            decrement={controlChildren.decrement}
            decrementLabel={labels.decrement + childLabel}
            increment={controlChildren.increment}
            incrementLabel={labels.increment + childLabel}
            isDecrementDisabled={controlChildren.isDecrementDisabled}
            isIncrementDisabled={controlChildren.isIncrementDisabled}
            name="children"
            value={controlChildren.value}
          />
        </div>
        <div
          className="
            mt-4 flex justify-between border-b border-border-variant-low pb-4
          "
        >
          <div className="me-4 min-w-40">{labels.infantsRestrictions}</div>
          <Incrementer
            decrement={controlInfants.decrement}
            decrementLabel={labels.decrement + infantLabel}
            increment={controlInfants.increment}
            incrementLabel={labels.increment + infantLabel}
            isDecrementDisabled={controlInfants.isDecrementDisabled}
            isIncrementDisabled={controlInfants.isIncrementDisabled}
            name="infants"
            value={controlInfants.value}
          />
        </div>
        <div className="mt-4 justify-between pb-4 text-foreground-on-surface">
          <p
            className="
              me-4 min-w-40 text-legal

              data-[emphasize-rule=true]:font-bold
            "
            data-emphasize-rule={
              controlAdults.isIncrementDisabled &&
              controlChildren.isIncrementDisabled
            }
          >
            {labels.maximumTravelers}
          </p>

          <p
            className="
              me-4 min-w-40 text-legal

              data-[emphasize-rule=true]:font-bold
            "
            data-emphasize-rule={
              controlChildren.value > 0 &&
              controlAdults.value === 0 &&
              controlChildren.value === MAX_CHILDREN_WITHOUT_ADULT
            }
          >
            {labels.maximumChildren}
          </p>

          <p
            className="
              me-4 min-w-40 text-legal

              data-[emphasize-rule=true]:font-bold
            "
            data-emphasize-rule={controlInfants.isIncrementDisabled}
          >
            {labels.maximumInfants}
          </p>

          <div
            className="
              me-4 mt-3 min-w-40 text-legal

              [&_a]:text-foreground-primary [&_a]:focus-outline

              [&_a:hover]:text-foreground-primary-variant [&_a:hover]:underline
            "
            dangerouslySetInnerHTML={{ __html: labels.specialAssistance }}
          />
          <div
            className="
              me-4 min-w-40 pt-3 text-legal

              [&_a]:text-foreground-primary [&_a]:focus-outline

              [&_a:hover]:text-foreground-primary-variant [&_a:hover]:underline
            "
            dangerouslySetInnerHTML={{ __html: labels.needHelp }}
          />
        </div>
      </>
    </Dropdown>
  );
};
